/*
 *###############################################################################
 *Module Name                   : PaymentMode.js                                #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               : M A P A Wijetunge                             #
 *Date                          : Wednesday, August 25th 2021, 12:40:07 pm      #
 *Copyright © 2021 myPOS Software Solution (Pvt) Ltd.                           #
 *###############################################################################
 */

import React, { useEffect, useState, useContext } from "react"
import MetaTags from "react-meta-tags"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  TabContent,
  TabPane,
  Alert
} from "reactstrap"

//**Importing required componant files   */
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import DPNavBar from "../../../framework/widgets/DPNavBar"
import DPInfoBox from "../../../framework/layout/DPInfoBox"
import DPTopToolBar from "../../../framework/widgets/DPTopToolBar"
import PaymentModeHedContent from "./PaymentModeHedContent" // Content of the Header information Tab
import PaymentModeDetContent from "./PaymentModeDetContent" // Content of the Detail information Tab
import { Text, Numeric, DecimalValidation } from "../../../framework/validators/TextValidation" // Textbox input validations
import { getPaymentModeByHedCode, setPaymentModes } from "../PaymentModeHed/PaymentModeController" // Api Call Controller Methods
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from "framework/widgets/DPPermission"
import * as XLSX from "xlsx";
import DPPrintOption from "framework/widgets/DPPrintOptions"
//**End Importing required componant files */

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';

const PaymentMode = props => {
  //**Set Active Tab panel */
  const [customActiveTab, setcustomActiveTab] = useState("1")
  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
    }
  }

  //**Create list of tab panels */
  const tabList = [
    {
      text: "Payment Modes",
      icon: "fas fa-home",
      tabID: "1",
      onClick: () => {
        toggleCustom("1")
      },
    },
    {
      text: "Detail Types",
      icon: "far fa-user",
      tabID: "2",
      onClick: () => {
        toggleCustom("2")
      },
    },
  ]

  const [newMenu] = useState(localStorage.getItem(window.location.pathname))
  let history = useHistory();
  //**Set Values of the controls of Header infor. Tab (Tab==1) */
  const [strPayHedCode, SetPayHedCode] = useState("")
  const [strPayHedDesc, SetPayHedDesc] = useState("")
  const [dblPayHedMaxLimit, SetPayHedMaxLimit] = useState("")
  const [intPayHedSeq, SetPayHedSeq] = useState("")
  const [strPayHedAPIParam, SetPayHedAPIParam] = useState("")
  const [blPayHedActive, SetPayHedActive] = useState(true)
  const [blPayHedLinkDetail, SetPayHedLinkDetail] = useState(false)
  const [blPayHedLinkLoyalty, SetPayHedLinkLoyalty] = useState(false)
  const [blPayHedLinkMyPay, SetPayHedLinkMyPay] = useState(false)
  const [blPayHedLinkWithOverPay, SetPayHedLinkWithOverPay] = useState(false)
  const [blPayHedOverPay, SetPayHedOverPay] = useState(false)
  const [blPayHedGV, SetPayHedGV] = useState(false)
  const [blPayHedCredit, SetPayHedCredit] = useState(false)
  const [blPayHedPromotion, SetPayHedPromotion] = useState(false)
  const [blPayHedRefunds, SetPayHedRefunds] = useState(false)
  const [blPayHedDefault, SetPayHedDefault] = useState(false)
  const [intPoint, setintpoint] = useState("0")
  const [blPayHedSignOff, SetPayHedSignOff] = useState(false)
  const [DataTables, SetDatatable] = useState([{ ID: 1 }])
  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [AlertShow, setAlertShow] = useState(false)
  const [AlertColor, setAlertColor] = useState("")
  const [AlertMsg, setAlertMsg] = useState("")
  const [menuCode, SetMenuCode] = useState("")
  //**End Set Values of the controls of Header infor. Tab (Tab==1) */

  //Alert Parameter
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
  const [ErrorMsg, setErrorMsg] = useState('')
  const [addNew, SetAddNew] = useState(true)

  //**Set Value for details */
  const [arPayModeDet, SetPayModeDet] = useState([])
  const [arRow, setarRow] = useState([{
    id: 1,
    code: "",
    desc: "",
    rate: "",
    state: false,
    order: "",
  }])
  const [deleteEnable, SetDeleteEnable] = useState(false)

  /* Button bar Enable Disable*/
  const [saveEnable, setSaveEnable] = useState(true)
  const [Disable, setDisable] = useState(false)
  const [DisableCode, setDisableCode] = useState(false)
  /* End Button bar Enable Disable*/

  //****User Activity Log Display related states*************************
  const [LogEnable, setCrEnable] = useState(false)
  const [crBy, setCrBy] = useState("") //Entry initially Created by
  const [mdBy, setMdBy] = useState("") //Entry Last Modified by
  const [crDate, setCrDate] = useState("") //Entry initially Created on
  const [mdDate, setMdDate] = useState("") //Entry last midified by
  const [Reason, setReason] = useState("Created")
  const [editEnable, SetEditEnable] = useState(false)
  //**End User Activity Log Display related states***********************

  //*****Menu Rights Start*/
  const [menuAccess, SetMenuAccess] = useState(false)
  const [menuCreate, SetMenuCreate] = useState(false)
  const [menuDelete, SetMenuDelete] = useState(false)
  const [menuModify, SetMenuModify] = useState(false)
  const [menuPrint, SetMenuPrint] = useState(false)
  const [menuProcess, SetMenuProcess] = useState(false)
  const [menuName, SetMenuName] = useState("")
  const [parentName, SetParentName] = useState("")
  const [LocationCode, setLocationCode] = useState("")
  const [LogUserType, setLogUserType] = useState("")
  const [LogCompanyCode, setLogCompanyCode] = useState("")
  //*****Menu Rights End */

  /**********Loading Alert */
  const [loadingAlert, SetLoadingAlert] = useState(false)
  const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
  /**********End Loading Alert */

  //autocode generation related newly added code
  const [codeButton, setCodeButton] = useState(true)
  const [searchdisabled, setSearchdisabled] = useState(false)
  const [nullCode, setNullCode] = useState(false)
  const [autoCode, setAutoCode] = useState(false)

  //User Permission related usestates
  const [permissionAlertShow, setPermissionAlertShow] = useState(false)
  const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
  const [permissionReasonShow, setPermissionReasonShow] = useState(false)
  const [permissionName, setPermissionName] = useState("")
  const [permissionPassword, setPermissionPassword] = useState("")
  const [permissionNameDisable, setPermissionNameDisable] = useState(false)
  const [printoptionShow, setprintoptionShow] = useState(false)
  const [valueUpload, setvalueUpload] = useState("")
  const [items, setItems] = useState([]);
  const [Excelitems, setExcelItems] = useState([]);
  const [ExcelSheet1, setExcelSheet1] = useState([]);

  const [currentPage, setCurrentPage] = useState(1)
  const [helpUrl, setHelpUrl] = useState("")

  //import from contexts
  const {
    isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode, addtoFavourite
  } = useContext(Context);
  //import from contexts

  var time = process.env.REACT_APP_ALERTTIMEOUT

  //**Get File Details */
  useEffect(async () => {
    const authToken = localStorage.getItem("authToken")
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
    var parentname = menuDetail?.parentName
    SetParentName(parentname)
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    setLocationCode(LocationCode)
    setLogUserType(LogUserType)
    setLogCompanyCode(CompanyCode)
    const ApiURL = window.Links.ApiURL
    SetMenuCode(menu)

    var responseData = await getSelectedMasterPermissions(LogUserType, menu)


    if (!responseData.strMenuAccessRight) {
      history.push('/dashboard')
    }

    SetMenuAccess(responseData.strMenuAccessRight)
    SetMenuCreate(responseData.strMenuCreateRight)
    SetMenuDelete(responseData.strMenuDeleteRight)
    SetMenuModify(responseData.strMenuModifyRight)
    SetMenuPrint(responseData.strMenuPrintRight)
    SetMenuProcess(responseData.strMenuProcessRight)
    SetMenuName(responseData.strMenuName)
    SetMenuCode(responseData.strMenuTag)
    setPermissionReasonShow(responseData.strMenuReasonShow)
    setHelpUrl(responseData.strHelpUrl)

    var autoCodeRes = await fetchAutoCode(menu)

    if (autoCodeRes.nullCode == false) {
      setAutoCode(autoCodeRes.autoCode)
    } else {
      setNullCode(true)
      setAutoCode("")
    }

  }, [strPayHedCode])

  // AuditLog
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu =
      menuDetail && menuDetail.menuTag
        ? menuDetail.menuTag
        : history.push("/dashboard")

    await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
  }, [])


  const readExcel = (file) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e) => {
        const bufferArray = e.target.result;

        const wb = XLSX.read(bufferArray, { type: "buffer" });

        const wsname = wb.SheetNames[0];
        const wsSheet1 = wb.SheetNames[1]

        const ws = wb.Sheets[wsname];

        const data = XLSX.utils.sheet_to_json(ws);
        const data2 = XLSX.utils.sheet_to_json(wb.Sheets[wsSheet1]);

        setExcelItems(data);
        setExcelSheet1(data2);
        resolve(data);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });

    promise.then((d) => {
      setItems(d);
    });
  };

  //**Recall and set values to relevant contrls based on the selected record from the search window  */
  const Hed_SelectRowSearch = (e, row, isSelect, rowIndex) => {
    ValueSetter(row.PH_CODE);
    setmodal_xlarge(!modal_xlarge)
  }
  // Set values to variables
  const ValueSetter = async (code) => {

    if (validateSpecialCharacters(code) == true) {
      SetPayHedCode("")
      return
    }

    if (code != "") {
      SetLoadingAlert(true)
      SetLoadingAlerttitle("Fetching...")
      let Data = await getPaymentModeByHedCode(code);
      SetLoadingAlert(false)

      if (Data.length != 0) {
        setarRow([])
        let modifiedRows = []
        Data.map((dr) => {
          SetPayHedCode(dr.pH_CODE)
          SetPayHedDesc(dr.pH_DESC)
          SetPayHedActive(BoolSetter(dr.pH_STATUS))
          SetPayHedLinkDetail(BoolSetter(dr.pH_DETAILS))
          SetPayHedLinkLoyalty(BoolSetter(dr.pH_LINKLOYALTY))
          SetPayHedOverPay(BoolSetter(dr.pH_OVERPAY))
          SetPayHedGV(BoolSetter(dr.pH_LINKGV))
          SetPayHedCredit(BoolSetter(dr.pH_LINKCREDIT))
          SetPayHedPromotion(BoolSetter(dr.pH_LINKPROMO))
          SetPayHedRefunds(BoolSetter(dr.pH_REFUNDMODE))
          SetPayHedDefault(BoolSetter(dr.pH_DEFAULT))
          SetPayHedMaxLimit(parseFloat(dr.pH_MAXLIMIT).toFixed(2));
          SetPayHedSignOff(BoolSetter(dr.pH_SW_SIGNOFF))
          SetPayHedSeq(dr.pH_ORDER)
          SetPayHedAPIParam(dr.pH_APISP)
          SetPayModeDet(dr.m_TBLPAYMODEDET)
          setintpoint(dr.pH_POINTSPER)
          SetPayHedLinkMyPay(BoolSetter(dr.pH_LINKMYPAY))
          SetPayHedLinkWithOverPay(BoolSetter(dr.pH_LINKWITHOVERPAY))
          setDisable(true)
          setDisableCode(true)
          setReason("Updated")
          SetEditEnable(true)
          //Set Audit log details for the recalled records****
          setCrBy(dr.cR_BY)
          setMdBy(dr.mD_BY)
          setCrDate(dr.cR_DATE)
          setMdDate(dr.mD_DATE == "1900-01-01T00:00:00" ? "" : dr.mD_DATE)

          dr.m_TBLPAYMODEDET.map((dr) => {
            modifiedRows.push({ id: modifiedRows.length + 1, code: dr.pD_CODE, desc: dr.pD_DESC, format: dr.pD_FORMAT, order: dr.pD_ORDER, rate: dr.pD_RATE, state: dr.pD_REQDATE, payCodeDisable: true })
          })
          setarRow(modifiedRows.length == undefined || modifiedRows.length == 0 ? [{ id: 1 }] : modifiedRows)
        })
        // setarRow(modifiedRows)
        //Disable controls after recall data
        SetAddNew(false)
        setSaveEnable(false)
        setCrEnable(true)
        SetDeleteEnable(true)
        setSearchdisabled(true)
      } else {
        if (nullCode == false) {
          displayAlertMessage('success', "Record Not Found !")
          setDisableCode(true)
          SetPayHedCode("")
        } else {
          displayAlertMessage('success', "Record Not Found !")
        }
      }
    }
  }

  //Set Bool value against 1 or 0
  const BoolSetter = (para) => {
    if (para == "1") {
      return true
    } else {
      return false
    }
  }

  // set new state
  const handleNewClick = () => {
    setcustomActiveTab("1")
    SetPayHedCode("")
    SetPayHedDesc("")
    SetPayHedActive(true)
    SetPayHedLinkDetail(false)
    SetPayHedLinkLoyalty(false)
    SetPayHedOverPay(false)
    SetPayHedGV(false)
    SetPayHedCredit(false)
    SetPayHedPromotion(false)
    SetPayHedRefunds(false)
    SetPayHedDefault(false)
    SetPayHedMaxLimit("");
    SetPayHedSignOff(false)
    SetPayHedSeq("")
    setintpoint("")
    SetPayHedAPIParam("")
    setarRow([{
      id: 1,
      code: "",
      desc: "",
      rate: "",
      state: false,
      order: "",
    }])

    SetDeleteEnable(false)
    setDisableCode(false)
    setDisable(false)
    SetPayHedLinkMyPay(false)
    SetPayHedLinkWithOverPay(false)
    //Set Audit log details for the recalled records****
    setCrBy("")
    setMdBy("")
    setCrDate("")
    setMdDate("")
    setSaveEnable(true)
    setCrEnable(false)
    SetAddNew(true)
    setErrorMsg("")
    SetDeleteEnable(false)
    setNullCode(false)
    setSearchdisabled(false)
    setReason("Created")
    SetEditEnable(false)
    setSaveEnable(true)
    setPermissionName("")
    setPermissionPassword("")
    setPermissionNameDisable(false)
    setExcelItems([])
    setExcelSheet1([])
    setCurrentPage(1)
  }

  // Enable edit
  const handleEditClick = () => {
    setDisable(false)
    setDisableCode(true)
    setSaveEnable(true)

    SetDeleteEnable(true)
    SetEditEnable(false)
  }

  //* To control detail table */

  //* end detail table controller */
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }
  // Table Data
  var searchData = [];
  const TableDataBuilder = (id, Data) => {
    let act = Data.pH_STATUS == 1 ? "Active" : "Inactive";
    return { "id": id, "code": Data.pH_CODE, "name": Data.pH_DESC, "active": act, "crby": Data.cR_BY, "crdate": Data.cR_DATE, "mdby": Data.mD_BY, "mddate": Data.mD_DATE }
  }


  //Save Data
  const SaveData = async () => {
    var ExcelItemsRows = [...Excelitems]
    var ExcelSheet1Rows = [...ExcelSheet1]
    if (Array.isArray(ExcelItemsRows) && ExcelItemsRows.length) {
      var erroecount = 0
      var excelrowcount = ExcelItemsRows.length
      const maps = ExcelItemsRows.map(
        async (localState) => {
          if ((localState.pH_CODE != "") && (localState.pH_DESC != "") && (localState.pH_MAXLIMIT != "") && (localState.pH_ORDER != "")) {
            var pays = []
            var code = localState.pH_CODE
            var desc = localState.pH_DESC
            var status = localState.pH_STATUS == null ? 0 : localState.pH_STATUS
            var details = localState.pH_DETAILS == null ? 0 : localState.pH_DETAILS
            var overpay = localState.pH_OVERPAY == null ? 0 : localState.pH_OVERPAY
            var linkloyalty = localState.pH_LINKLOYALTY == null ? 0 : localState.pH_LINKLOYALTY
            var linkcredit = localState.pH_LINKCREDIT == null ? 0 : localState.pH_LINKCREDIT
            var linkgv = localState.pH_LINKGV == null ? 0 : localState.pH_LINKGV
            var linkpropmo = localState.pH_LINKPROMO == null ? 0 : localState.pH_LINKPROMO
            var refundmode = localState.pH_REFUNDMODE == null ? 0 : localState.pH_REFUNDMODE
            var pointsper = localState.pH_POINTSPER == null ? 0 : localState.pH_POINTSPER
            var default1 = localState.pH_DEFAULT == null ? 0 : localState.pH_DEFAULT
            var order = localState.pH_ORDER == null ? 0 : localState.pH_ORDER
            var maxlimit = localState.pH_MAXLIMIT == null ? 0 : localState.pH_MAXLIMIT
            var apisp = localState.pH_APISP == null ? "" : localState.pH_APISP
            var signoff = localState.pH_SW_SIGNOFF == null ? 0 : localState.pH_SW_SIGNOFF
            var linkmyPay = localState.pH_LINKMYPAY == null ? 0 : localState.pH_LINKMYPAY
            var linkOverpay = localState.pH_LINKWITHOVERPAY == null ? 0 : localState.pH_LINKWITHOVERPAY

            if (localState.pH_DETAILS == 1) {
              if (Array.isArray(ExcelSheet1Rows) && ExcelSheet1Rows.length) {
                ExcelSheet1Rows.map(dr => {
                  if (dr.pD_PHCODE == localState.pH_CODE) {

                    var pD_CODE = dr.pD_CODE == null ? "" : dr.pD_CODE
                    var pD_DESC = dr.pD_DESC == null ? "" : dr.pD_DESC
                    var pD_FORMAT = dr.pD_FORMAT == null ? "" : dr.pD_FORMAT
                    var pD_RATE = dr.pD_RATE == null ? 0 : dr.pD_RATE
                    var pD_REQDATE = dr.pD_REQDATE == null ? 0 : dr.pD_REQDATE
                    var pD_ORDER = dr.pD_ORDER == null ? 0 : dr.pD_ORDER

                    if (pD_CODE != "") {
                      pays.push(PayDetBuilder(localState.pH_CODE, pD_CODE, pD_DESC, pD_FORMAT, pD_RATE, pD_REQDATE, pD_ORDER))
                    }
                  }
                })
              }
            }

            let strResult = await setPaymentModes(code, desc, status, details, overpay, linkloyalty, linkcredit, linkgv, linkpropmo, refundmode, pointsper, default1, order, maxlimit, apisp, signoff, pays, addNew, menuCode, LogCompanyCode, LocationCode, LogUserType, Reason, linkmyPay, linkOverpay)

            if (strResult.status == "200") {
              await strResult.json()
                .then(responseData => {
                  if (responseData.data == "Record Already Exsist!") {
                    erroecount++
                  } else if (responseData.data == "Code Already Exsist!") {
                    erroecount++
                  }
                }
                )
            } else if (strResult.status == "400") {
              erroecount++
            } else {
              erroecount++
            }
          } else {
            erroecount++
          }
        }
      )

      await Promise.all(maps)
      setAlertMsg(`From ${excelrowcount} Records, ${excelrowcount - erroecount} Records Inserted Successfully, ${erroecount} Records Failed To Insert`)
      if ((excelrowcount - erroecount) > erroecount) {
        setAlertColor('success')
      } else {
        setAlertColor('danger')
      }
      setAlertShow(true)
      // setTimeout(() => {
      //   setAlertShow(false)
      // }, 6000)

    } else {
      //set autogenerate code to as CODE just for display purpuse
      if (addNew == true && nullCode == false) {
        SetPayHedCode(autoCode)
      }

      if (strPayHedCode.length == 0 && nullCode == true) {
        displayAlertMessage('danger', "Pay Head Code is Empty !")
        return;

      }
      if (strPayHedDesc.length == 0) {
        displayAlertMessage('danger', "Pay Head Descripton is Empty !")
        return;

      }
      if (dblPayHedMaxLimit.length == 0) {
        displayAlertMessage('danger', "Pay Head Maximum Limit is Empty !")
        return;

      }
      if (intPayHedSeq.length == 0) {
        displayAlertMessage('danger', "Pay Head Display Sequence is Empty !")
        return;

      }
      var payDet = [];

      if (blPayHedLinkDetail) {
        for (var i = 0; i < arRow.length; i++) {

          if (arRow[i].code != "") {
            // if (arRow[i].format == "") {
            //   displayAlertMessage('danger', "Format could not be empty !")
            //   return;
            // }

            payDet.push(PayDetBuilder(strPayHedCode, arRow[i].code, arRow[i].desc, arRow[i].format, arRow[i].rate, arRow[i].state, arRow[i].order))

          } else {
            displayAlertMessage('danger', " Details code is empty in Details type table row number " + (i + 1) + " !")
            return;
          }
        }
      }

      var Point = blPayHedLinkLoyalty == false ? "0" : intPoint
      //loading alert show
      SetLoadingAlert(true)
      if (addNew == true) {
        SetLoadingAlerttitle("Saving...")
      } else {
        SetLoadingAlerttitle("Updating...")
      }

      var code = addNew == true && nullCode == false ? autoCode : strPayHedCode

      let strResult = await setPaymentModes(code, strPayHedDesc, setIntFromBool(blPayHedActive), setIntFromBool(blPayHedLinkDetail), setIntFromBool(blPayHedOverPay), setIntFromBool(blPayHedLinkLoyalty), setIntFromBool(blPayHedCredit), setIntFromBool(blPayHedGV), setIntFromBool(blPayHedPromotion), setIntFromBool(blPayHedRefunds), Point, setIntFromBool(blPayHedDefault), intPayHedSeq, dblPayHedMaxLimit, strPayHedAPIParam, setIntFromBool(blPayHedSignOff), payDet, addNew, menuCode, LogCompanyCode, LocationCode, LogUserType, Reason, setIntFromBool(blPayHedLinkMyPay), setIntFromBool(blPayHedLinkWithOverPay))

      if (strResult.status == "200") {
        SetLoadingAlert(false)
        strResult.json()
          .then(responseData => {
            if (responseData.data == "Record Already Exsist!") {
              displayAlertMessage('danger', responseData.data)

            } else if (responseData.data == "Code Already Exsist!") {
              displayAlertMessage('danger', responseData.data)
              setCodeButton(false)
            } else {
              handleNewClick();
              displayAlertMessage('success', responseData.data)

            }
          }
          )
      } else if (strResult.status == "400") {
        SetLoadingAlert(false)
        displayAlertMessage('danger', "Oops something went wrong !")

      } else {
        SetLoadingAlert(false)
        handleNewClick()
      }
    }
  }

  const setIntFromBool = (blParameter) => {
    if (blParameter) {
      return 1;
    } else {
      return 0;
    }
  }

  const PayDetBuilder = (PayhedCode, txtcode, txtdesc, txtformat, txtrate, swdatereq, txtorder,) => {
    return {
      "pD_PHCODE": PayhedCode,
      "pD_CODE": txtcode,
      "pD_DESC": txtdesc,
      "pD_FORMAT": txtformat,
      "pD_RATE": parseFloat(txtrate ?? 0),
      "pD_REQDATE": setIntFromBool(swdatereq),
      // "pdreqdate": setIntFromBool(PaydatereqData),
      "pD_ORDER": parseInt(txtorder ?? 0)
    }
  }

  ///** Functions for Payment Details handle */
  function handleAddRowNested() {
    const modifiedRows = [...arRow]
    modifiedRows.push({ id: modifiedRows.length + 1 })
    setarRow(modifiedRows)
  }

  function handleRemoveRow(id) {
    if (id !== 0) {
      var modifiedRows = [...arRow]
      modifiedRows = modifiedRows.filter(x => x["id"] !== id)
      setarRow(modifiedRows)
    }
  }
  ///**End Function define for payment details */
  //var tbl = document.getElementById("txtcode0");
  // print Function
  // print Function
  async function handlePrint(option) {
    const authToken = localStorage.getItem("authToken")
    var option = option

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Generating Report...")

    const ReportURL = window.Links.ReportURL
    await fetch(`${ReportURL}api/paymode/report/${LogUserType}/${option == "PDF" ? 1 : 0}`, {
      method: "GET",
      headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` }
    }).then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          if (option == "PDF") {
            const msg = responseData.msg
            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
          }
          if (option == "XCEL") {
            const msg = responseData.msg
            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)
          }

        }
        SetLoadingAlert(false)
      }).catch(error => {
        console.log(error.message)
        SetLoadingAlert(false)
      })
  }

  //********Delete button function */
  const handleDelete = () => {

    const ApiURL = window.Links.ApiURL

    const rowDelete = {
      "strMenuCode": menuCode,
      "strCode": strPayHedCode,
      "strLoggedCompany": LogCompanyCode,
      "strLoggedLocation": LocationCode,
      "strReason": Reason,
      "strCreateBy": crBy
    }

    //loading alert show
    SetLoadingAlert(true)
    SetLoadingAlerttitle("Deleting...")
    const authToken = localStorage.getItem("authToken")

    fetch(`${ApiURL}Common/Delete`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        body: JSON.stringify(rowDelete)
      }
    ).then(Response => {

      if (Response.status == "200") {
        SetLoadingAlert(false)
        Response.json()
          .then(responseData => {

            if (responseData.data == "Cannot Delete, Record Already Used!") {
              displayAlertMessage('warning', responseData.data)

            } else {
              handleNewClick();
              displayAlertMessage('success', responseData.data)
            }
          }
          )
      } else if (Response.status == "400") {
        SetLoadingAlert(false)
        setDisable(false)
        setDisableCode(false)
        displayAlertMessage('success', responseData.data)

      } else {
        SetLoadingAlert(false)
        handleNewClick()
      }
    }).catch(error => {
      console.log(error.message)
    })

  }
  //*********Delete button function end */

  //CODE AUTO GEN
  const AutoGenerateCode = async () => {
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL
    await fetch(`${ApiURL}common/autocode/${menuCode}`, {
      method: "GET",
      headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
    }).then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          if (responseData.data.length > 0) {
            SetPayHedCode(responseData.data)
            setAutoCode(responseData.data)
          }
          // else {
          //   setDisableCode(false)
          // }
        }
      })
  }


  //**Permission Check */
  const permission = (operation) => {
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL
    const permissiondata = {
      strUsername: permissionName,
      strPassword: permissionPassword,
      strLocation: LocationCode,
      strMenuCode: menuCode
    }

    clearPermissionInputs() //clear username & password

    fetch(`${ApiURL}login/userpermission`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        body: JSON.stringify(permissiondata)
      }
    ).then(Response => {
      if (Response.status == "200") {
        Response.json()
          .then(responseData => {

            let Access = (responseData.data.strMenuAccessRight)
            let Create = (responseData.data.strMenuCreateRight)
            let Delete = (responseData.data.strMenuDeleteRight)
            let Modify = (responseData.data.strMenuModifyRight)
            let Print = (responseData.data.strMenuPrintRight)
            let Process = (responseData.data.strMenuProcessRight)

            if (operation == "Save") {
              if (Create == true) {
                SaveData()
              } else if (Modify == true) {
                SaveData()
              } else {
                displayAlertMessage('danger', `This user don't have permisiion to ${addNew == true ? "save " : " update "} !`)

              }
            } else if (operation == "Delete") {
              if (Delete == true) {
                handleDelete()
              } else {
                displayAlertMessage('danger', "This user don't have permission to delete !")

              }
            } else if (operation == "Print") {
              if (Print == true) {
                setprintoptionShow(true)
              } else {
                displayAlertMessage('danger', "This user don't have permission to print !")

              }
            }
          }
          )

      } else if (Response.status == "400") {
        setDisable(false)
        setDisableCode(false)
        displayAlertMessage('danger', "Oops something went wrong !")
        clearPermissionInputs()

      } else if (Response.status == "403") {
        setDisable(false)
        setDisableCode(false)
        displayAlertMessage('danger', "You have not Permission to make changes !")
        clearPermissionInputs()

      } else if (Response.status == "404") {
        setDisable(false)
        setDisableCode(false)
        displayAlertMessage('danger', "Password or User Name is Invalid !")
        clearPermissionInputs()

      } else {
        handleNewClick()
      }
    }).catch(error => {
      console.log(error.message)
    })
  }


  /*
    Function for displaying Alert Messages.
  */

  function displayAlertMessage(color, message) {
    setAlertColor(color)
    setAlertMsg(message)
    setAlertShow(true)

    setTimeout(() => {
      setAlertShow(false)
    }, time)
  }


  //handle permission alert
  function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
    setPermissionName(LogUserType)
    setReason(reason)
    setPermissionNameDisable(disable)
    setPermissionAlertShow(alertShow)
  }


  //Clear permission name & password
  function clearPermissionInputs() {
    setPermissionName("");
    setPermissionPassword("");
    setReason("");
  }


  //Handle Favourite Button
  const handleFavourite = async () => {
    var response = await addtoFavourite(menuCode, LogUserType);
  }


  const validateSpecialCharacters = (str) => {
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
    return specialCharRegex.test(str);
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{menuName}</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs title={parentName} breadcrumbItem={menuName} />
          <DPAlert
            confirm_both={sweetAlertShow}
            title={menuName}
            description={AlertDescription}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            onConfirm={() => {
              setsweetAlertShow(false)
              // if (AlertConfirmOption == 1) {
              //   SaveData()
              // } else if (AlertConfirmOption == 2) {
              //   handleEditClick()
              // } else if (AlertConfirmOption == 3) {
              //   window.location.href = "/";
              // } else if (AlertConfirmOption == 4) {
              //   handleNewClick()
              // } else if (AlertConfirmOption == 5) {
              //   SetPayHedLinkDetail(!blPayHedLinkDetail)
              //   setarRow([])
              // } else if (AlertConfirmOption == 6) {
              //   handleDelete()
              // }

              if (AlertConfirmOption == 1) {

                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                  SaveData()
                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Created", true, true)
                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                  SaveData()
                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Updated", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }

              } else if (AlertConfirmOption == 2) {
                handleEditClick()
              } else if (AlertConfirmOption == 3) {
                history.push('/dashboard')
              } else if (AlertConfirmOption == 4) {
                handleNewClick()
                setAlertShow(false)
              } else if (AlertConfirmOption == 5) {
                SetPayHedLinkDetail(!blPayHedLinkDetail)
                setarRow([])
              } else if (AlertConfirmOption == 7) {
                if (menuPrint == true && permissionReasonShow == false) {
                  setprintoptionShow(true)
                } else if (menuPrint == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Printed", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }
              } else if (AlertConfirmOption == 6) {

                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                  handleDelete()
                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Deleted", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }

              }

            }}
            onCancel={() => {
              setsweetAlertShow(false)
            }}
          />
          <DPPermission
            confirm_both={permissionAlertShow}
            title={menuName}
            description={permissionAlertTitle}
            showReason={permissionReasonShow}
            nameDisable={permissionNameDisable}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            AlName={permissionName}
            AlNameOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setPermissionName(val2)
            }}
            AlPassward={permissionPassword}
            AlPasswardOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setPermissionPassword(val2)
            }}
            AlReason={Reason}
            AlReasonOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setReason(val2)
            }}
            onConfirm={() => {
              setPermissionAlertShow(false)
              if (AlertConfirmOption == 1) {
                permission("Save")
              } else if (AlertConfirmOption == 6) {
                permission("Delete")
              } else if (AlertConfirmOption == 7) {
                permission("Print")
              }
            }}
            onCancel={() => {
              setPermissionAlertShow(false)
              clearPermissionInputs()
            }}
          />
          <DPPrintOption
            confirm_both={printoptionShow}
            title={menuName}

            showCancel={true}
            cancelColor={"danger"}
            onConfirmpdf={() => {
              handlePrint("PDF")
              setprintoptionShow(false)
            }}
            onConfirmxcel={() => {
              handlePrint("XCEL")
              setprintoptionShow(false)
            }}
            onCancel={() => {
              setprintoptionShow(false)
            }}
          />
          <DPLoadingAlert
            confirm_both={loadingAlert}
            title={loadingAlertTitle}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <DPTopToolBar
                    //Help Button
                    helpEnable={helpUrl != "" ? true : false}
                    helpClick={() => {
                      window.open(helpUrl)
                    }}
                    //Favorite Button
                    favoriteEnable={true}
                    favoriteClick={handleFavourite}
                    //New Button
                    newEnable={true}
                    newClick={() => {
                      setAlertDescription("Do you wish to refresh the screen ?");
                      setAlertConfirmOption(4)
                      setsweetAlertShow(true)

                    }}
                    //Save Button
                    saveEnable={saveEnable && isHeadOffice}
                    saveClick={() => {
                      setAlertDescription("Do you wish to save ?");
                      setAlertConfirmOption(1)
                      setsweetAlertShow(true)
                    }}
                    //ProcessButton
                    processEnable={false}
                    processClick={() => {
                      alert("Process")
                    }}
                    //Edit Button
                    editEnable={!saveEnable && isHeadOffice}
                    editClick={() => {
                      setAlertDescription("Do you wish to edit ?");
                      setAlertConfirmOption(2)
                      setsweetAlertShow(true)
                    }}
                    //Print Button
                    //Print Button
                    printEnable={true}
                    printClick={() => {
                      setReason("Printed")
                      setAlertDescription("Do you wish to Print ?");
                      setAlertConfirmOption(7)
                      setsweetAlertShow(true)
                    }}
                    //Delete Button
                    deleteEnable={deleteEnable}
                    deleteClick={() => {
                      setReason("Deleted")
                      setAlertDescription("Do you wish to delete ?");
                      setAlertConfirmOption(6)
                      setsweetAlertShow(true)
                    }}
                    //Exit Button
                    exitEnable={true}
                    exitClick={() => {
                      setAlertDescription("Do you wish to exit ?");
                      setAlertConfirmOption(3)
                      setsweetAlertShow(true)
                    }}
                  />
                  <p />
                  <DPNavBar buttons={tabList} activeStatus={customActiveTab} />
                  <TabContent activeTab={customActiveTab} className="p-3 text">
                    {AlertShow ? (
                      <Alert color={AlertColor} role="alert">
                        {AlertMsg}
                        <br />
                        <small>{ErrorMsg}</small>
                      </Alert>
                    ) : null}
                    <TabPane tabId="1">
                      <PaymentModeHedContent
                        menuName={menuName}
                        Hed_SelectRowSearch={Hed_SelectRowSearch}
                        Hed_Code={strPayHedCode}
                        Hed_Code_onKeyPress={(e) => {
                          if (e.charCode == 13) {
                            ValueSetter(strPayHedCode)
                          }

                        }}
                        onBlur={() => {
                          ValueSetter(strPayHedCode)
                        }}
                        Hed_Code_OnChange={e => {
                          let valCode = Text(e.target, 5, true, false, "upper", false)
                          SetPayHedCode(valCode)
                        }}

                        Hed_Desc={strPayHedDesc}
                        Hed_Desc_OnChange={e => {
                          let valDesc = Text(e.target, 20, true, false, "any", true)
                          SetPayHedDesc(valDesc)
                        }}
                        HedDataSearch={async () => {
                          tog_xlarge();
                        }}
                        DataTables={DataTables}
                        Hed_CodeSearchOpen={modal_xlarge}
                        Hed_CodeSearchTrigger={tog_xlarge}
                        Hed_MaxLimit={dblPayHedMaxLimit}
                        Hed_MaxLimit_OnChange={(e) => {
                          let valMaxlmt = Numeric(e.target, 8, 2, false)
                          SetPayHedMaxLimit(valMaxlmt)
                        }}


                        Hed_MaxLimit_OnBlur={() => {
                          var value = DecimalValidation(dblPayHedMaxLimit, 0, true)
                          SetPayHedMaxLimit(value)
                        }}


                        Hed_DispSeq={intPayHedSeq}
                        Hed_DispSeq_OnChange={(e) => {
                          let varSeq = Numeric(e.target, 3, 0, false)
                          SetPayHedSeq(parseInt(varSeq.length == 0 ? 0 : varSeq))
                        }}

                        Hed_APIParam={strPayHedAPIParam}
                        Hed_APIParam_OnChange={(e) => {
                          let varApi = Text(e.target, 15, true, true, "normal", true)
                          SetPayHedAPIParam(varApi)
                        }}
                        Hed_Active={blPayHedActive}
                        Hed_Active_OnChange={() => {
                          SetPayHedActive(!blPayHedActive);
                        }}
                        Hed_LinkDetail={blPayHedLinkDetail}
                        Hed_LinkDetail_OnChange={() => {
                          if (blPayHedLinkDetail) {
                            setAlertDescription("Do you wish to remove payment detail section ?");
                            setAlertConfirmOption(5)
                            setsweetAlertShow(true)
                          } else {
                            SetPayHedLinkDetail(!blPayHedLinkDetail)
                          }

                        }}
                        Hed_LinkLoyalty={blPayHedLinkLoyalty}
                        Hed_LinkLoyalty_OnChange={() => {
                          SetPayHedLinkLoyalty(!blPayHedLinkLoyalty)


                        }}

                        Hed_OverPay={blPayHedOverPay}
                        Hed_OverPay_OnChange={() => {
                          SetPayHedOverPay(!blPayHedOverPay)
                        }}

                        Hed_GV={blPayHedGV}
                        Hed_GV_OnChange={() => {
                          SetPayHedGV(!blPayHedGV)
                        }}
                        Hed_Credit={blPayHedCredit}
                        Hed_Credit_OnChange={() => {
                          SetPayHedCredit(!blPayHedCredit)
                        }}
                        Hed_Promotion={blPayHedPromotion}
                        Hed_Promotion_OnChange={() => {
                          SetPayHedPromotion(!blPayHedPromotion)
                        }}

                        Hed_Refunds={blPayHedRefunds}
                        Hed_Refunds_OnChange={() => {
                          SetPayHedRefunds(!blPayHedRefunds)
                        }}
                        Hed_Default={blPayHedDefault}
                        Hed_Default_OnChange={() => {
                          SetPayHedDefault(!blPayHedDefault)
                        }}
                        Hed_SignOff={blPayHedSignOff}
                        Hed_SignOff_OnChange={() => {
                          SetPayHedSignOff(!blPayHedSignOff)
                        }}
                        DisableCode={DisableCode}
                        Disable={Disable}
                        ErrorMsg={ErrorMsg}
                        HedAlertDispayStatus={AlertShow}
                        HedAlertColor={AlertColor}
                        HedAlertMsg={AlertMsg}
                        intPoint={intPoint}
                        intPointOnChange={(e) => {
                          let pointval = Numeric(e.target, 3, 0, false)
                          setintpoint(pointval)
                        }}
                        intPointBlur={(e) => {
                          let pointvalue = DecimalValidation(e.target.value, 0, false, 0)
                          setintpoint(pointvalue)
                        }
                        }
                        onButtonClick={e => {
                          AutoGenerateCode()
                          setCodeButton(true)
                        }}
                        btnDisable={codeButton}
                        SearchDisable={searchdisabled}
                        showFileUpload={(e) => {
                          const file = e.target.files[0];
                          readExcel(file);
                          setvalueUpload(e.target.value)
                        }}
                        valueUpload={valueUpload}
                        blPayHedLinkWithOverPay={blPayHedLinkWithOverPay}
                        blPayHedLinkMyPay={blPayHedLinkMyPay}
                        SetPayHedLinkMyPay={() => {

                          if (blPayHedLinkMyPay) {
                            SetPayHedLinkWithOverPay(false)
                            SetPayHedLinkMyPay(!blPayHedLinkMyPay)
                          } else {
                            SetPayHedLinkMyPay(!blPayHedLinkMyPay)
                          }


                        }}
                        SetPayHedLinkWithOverPay={() => {

                          if (blPayHedLinkMyPay) {
                            SetPayHedLinkWithOverPay(!blPayHedLinkWithOverPay)
                          } else {
                            SetPayHedLinkWithOverPay(false)
                            displayAlertMessage('danger', "Please enable Link with myPay to enable this option")
                          }

                        }}
                        menuCode={menuCode}
                        autoCode={autoCode}

                      />

                    </TabPane>
                    {blPayHedLinkDetail ? (<TabPane tabId="2">
                      <PaymentModeDetContent
                        DataRow={arRow}
                        setarRow={setarRow}
                        RemoveRow={handleRemoveRow}
                        AddRow={handleAddRowNested}
                        Disable={Disable}
                        menuCode={menuCode}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    </TabPane>) : null}
                  </TabContent>
                  <Row>
                    {LogEnable ? (
                      <DPInfoBox
                        createdBy={crBy}
                        createdOn={crDate != '1900-01-01 00:00:00' ? (crDate) ? crDate.replace('T', ' ') : "" : ''}
                        modifiedBy={mdBy}
                        modifiedOn={mdDate != '1900-01-01 00:00:00' ? (mdDate) ? mdDate.replace('T', ' ') : "" : ''}
                      />
                    ) : null}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
export default PaymentMode
